<template>
   <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
    <template #subHeaderActions>
      
    </template>
    <template #layoutContent> 
      <FormPreview
        :steps="defaultForm.steps"
        :note="note"
      />
    </template>
  </SubLayout>
  
</template>
<script setup>
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import { onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import FormPreview from "../../components/FormPreview.vue";

const store = useStore()
const route = useRoute()

const title = ref("") 
const note = ref("") 
const breadcrumbs = ref([
  {
    name: '',
    route: ''
  }
])

const getting = ref(false)
const defaultForm = ref([])

watch(() => route.query.tab, (value) => {
      loadEventForm()
      loadFieldTypes()
      loadFileExtensions()
})

const loadEventForm = async () => {
  try {
    getting.value = true;

    const [eventRes, formRes] = await Promise.all([
      store.dispatch('events/getEventDetail', route.params.id),
      store.dispatch('forms/getEventForm', route.params.form),
    ]);
    
    title.value = eventRes?.data?.data?.title;
    note.value = formRes?.data?.data?.note;
    defaultForm.value = formRes?.data?.data?.form; 
    breadcrumbs.value.name = formRes?.data?.data?.form.name
  } catch (error) {
    console.error('Erreur lors du chargement du formulaire de l’événement :', error);
  } finally {
    getting.value = false;
  }
};

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

const loadFileExtensions = () => {
  store.dispatch('nps/getFileExtensions')
}

onMounted(() => {
    loadEventForm()
    loadFieldTypes()
    loadFileExtensions()
})

</script>
<style scoped>
.card .card-body{
  padding: 0 !important;
}

.accordion-item{
  border: 0 !important;
}
.accordion-header{
  border-radius: .625rem !important;
}

.accordion-button{
  border-radius: .625rem !important;
}
</style>